export default __webpack_public_path__ + "static/media/es.576ad1e4.svg";